import { render, staticRenderFns } from "./AreaLayer.vue?vue&type=template&id=bf54c2be"
import script from "./AreaLayer.vue?vue&type=script&lang=js"
export * from "./AreaLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports